module.exports = __webpack_public_path__ + "static/wlbg03-8f7c55a2ac59ada6880b4e074ca4b611.jpg";